<script lang="ts">
  import { onMount, SvelteComponent } from "svelte";
  import { get } from "svelte/store";
  import Path from "./scripts/Path";
  import ProcMgr from "./stores/ProcMgr";

  import Notepad from "./windows/Notepad.svelte";
  import Logger from "./windows/Logger.svelte";
  import Terminal from "./windows/Terminal.svelte";
  import Finder from "./windows/Finder.svelte";
  import MarkdownEditor from "./windows/MarkdownEditor.svelte";
  import Browser from "./windows/Browser.svelte";
  import Wire from "./windows/Wire.svelte";
  import Atelier from "./windows/Atelier.svelte";
  import Hub from "./windows/Hub.svelte";
  import Postman from "./windows/Postman.svelte";
  import Bakery from "./windows/Bakery.svelte";
  import Modal from "./components/Modal.svelte";
  import About from "./windows/About.svelte";
  import Styler from "./windows/Styler.svelte";
  import Settings from "./windows/Settings.svelte";
  import Jamchinko from "./\bgames/Jamchinko.svelte";
  import ImageViewer from "./windows/ImageViewer.svelte";

  const procmgr = ProcMgr.getInstance();
  const { isModal, winStoreOrdered } = procmgr;

  const winCmdMap: { [key: string]: typeof SvelteComponent } = {
    notepad: Notepad,
    terminal: Terminal,
    logger: Logger,
    finder: Finder,
    markdown: MarkdownEditor,
    browser: Browser,
    wire: Wire,
    atelier: Atelier,
    hub: Hub,
    postman: Postman,
    bakery: Bakery,
    about: About,
    styler: Styler,
    settings: Settings,
    jamchinko: Jamchinko,
    viewer: ImageViewer,
    // 'editor' : Editor,
    // 'boot-loader' : Bootloader,
  };
  const view = (obj: {}) => {
    // console.log("View");
    // console.log(obj);
    return obj;
  };

  // $: procs = view($winStoreOrdered);
  onMount(() => {});
</script>

<div class="windows container">
  {#if $isModal}
    <Modal />
  {/if}
  {#if $winStoreOrdered.length}
    {#each $winStoreOrdered as win (win.props.id)}
      {#if winCmdMap[win.props.comp]}
        <svelte:component
          this={winCmdMap[win.props.comp]}
          winProps={win.props}
        />
      {:else}
        <div
          style={`position:fixed;top:30%;left:0%;width:100%;height:40%;background-color:white;color:black;text-align:center;font-size:3rem`}
          class="error"
        >
          <div
            class="error-msg"
            style={`position:absolute;width:100%;height:100%;top:50%;left:50%;transform:translate(-50%, 0%);`}
          >
            Component not found : {win.props.comp}
          </div>
        </div>
      {/if}
    {/each}
  {/if}
</div>

<style>
  .container {
    /* position: relative; */
    width: 100%;
    height: 100%;
    /* background-color: green; */
    background-color: transparent;
  }
</style>
